import dynamic from "next/dynamic";

export const DateRangePicker = dynamic(() => import("./DateRangePicker"), {
  ssr: false,
  // @ts-expect-error: next/dynamic 类型未声明 forwardRef，但实际13.4.X 已存在该属性。该属性以实现 ref 透传，否则父组件无法通过 ref 访问 DateRangePicker 实例方法
  forwardRef: true,
});
